// extracted by mini-css-extract-plugin
export var phone = "_35-0";